const log = require('log').create('needsSpotlightAuth') // eslint-disable-line

module.exports = function needsSpotlightAuth(spotlight) {
    switch (spotlight.mechanism) {
        case 'capture':
        case 'schedule':
            return ! spotlight.authenticated
        default:
            return false
    }
}
